import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../lib/auth-client.ts";
import { AUTH_COPY, authResultError, normalizeAuthError, type AuthBanner } from "../lib/auth-messages.ts";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<AuthBanner | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setNotice(null);
    setLoading(true);
    try {
      const res = await requestPasswordReset({
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      });
      const message = authResultError(res, "Could not send a reset link. Please try again.");
      if (message) {
        setError(message);
        return;
      }
      setNotice({ kind: "success", text: AUTH_COPY.passwordResetSent });
    } catch (err) {
      setError(normalizeAuthError(err, "Could not send a reset link. Please try again."));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-wrap animate-fade-in">
        <div className="auth-logo">
          <div className="auth-logo-mark">
            <img src="/logo.webp" alt="CurrencyCore" />
          </div>
          <h1>Reset your password</h1>
          <p>Get a secure link sent to your inbox</p>
        </div>

        <div className="auth-card">
          {error && <div className="auth-banner auth-banner-error">{error}</div>}
          {notice && <div className={`auth-banner auth-banner-${notice.kind}`}>{notice.text}</div>}

          <form onSubmit={handleSubmit} className="form-stack">
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="you@example.com"
              />
            </div>

            <button type="submit" disabled={loading} className="btn btn-primary btn-block">
              {loading ? (
                <>
                  <span className="spinner" />
                  Sending…
                </>
              ) : (
                "Email reset link"
              )}
            </button>
          </form>
        </div>

        <p className="auth-footer">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
